<template>
  <div class="x-form-cascader">
    <el-button @click="showChooseBox">
      {{resultText}}
      <i class="el-icon-arrow-down"></i>
    </el-button>
    <div class="choose-box" v-show="visible">
      <el-select v-model="chooseData[index]" v-for="(item, index) in selectList" placeholder="请选择" @change="query" size="small" :loading="loading[index]" style="width:160px;">
        <el-option
          v-for="it in item"
          :label="it[textField]"
          :value="it[valueField]">
        </el-option>
      </el-select>
      <el-button type="text" style="padding: 0 10px;" @click="hideChooseBox" icon="close"></el-button>
    </div>
  </div>
</template>

<script>
import ajax from './ajax'

export default {
  name: 'xcascader',
  props: ['value', 'url', 'valueField', 'textField', 'placeholder'],
  data() {
    return {
      visible: false,
      chooseData: [null],
      loading: [false],
      selectList: [
        [
          {
            id: 0,
            name: '请选择'
          }
        ]
      ],
      resultText: ''
    }
  },
  created(){
    this.init();
  },
  watch: {
    value() {
      this.init();
    }
  },
  methods: {
    init(){
      console.log(this.value);
      this.resultText = this.placeholder;
      if(this.textField == undefined){
        this.textField = 'name';
      }
      if(this.valueField == undefined){
        this.valueField = 'id';
      }
      this.query(0, -1);
    },
    showChooseBox(){
      this.visible = true;

    },
    hideChooseBox(){
      this.visible = false;
    },
    query(val, num){
      var _self = this;
      this.loading[num] = true;
      let defaultId = (this.chooseData[0] == null) ? 0 : this.chooseData[this.chooseData.length-1];
      ajax(this, 'get', this.url, {id: defaultId}, (res) => {
        let list = res.data.list;
        if(list.length != 0){
          if(num == undefined){
            num  = 0;
            for(let i in _self.chooseData){
              if(_self.chooseData[i] == val){
                num = i;
                break;
              }
            }
          }
          if(num*1 + 1*1 != _self.chooseData.length){
            _self.chooseData.splice(num*1 + 1*1, _self.chooseData.length - num - 1);
            _self.selectList.splice(num*1 + 1*1, _self.selectList.length - num - 1);
            _self.loading.splice(num*1 + 1*1, _self.loading.length - num - 1);
          }
          _self.selectList.push(res.data.list);
          _self.chooseData.push(null);
          _self.loading[num] = true;
        }else{
          // _self.$emit('input', _self.chooseData[_self.chooseData.length -1]);
          _self.$emit('input', val);
          let chooseText = '';
          let lastSelect = _self.selectList[_self.selectList.length -1]
          for(let i in lastSelect){
            if(lastSelect[i][_self.valueField] == _self.chooseData[_self.chooseData.length -1]){
              chooseText = lastSelect[i][_self.textField];
              break;
            }
          }
          _self.resultText = chooseText;
          _self.hideChooseBox();
        }
      }, () => {
        _self.loading[num] = false;
      })

    }
  }
}
</script>


// WEBPACK FOOTER //
// cascader.vue?3853e5cb